import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { SupplierRoutePath } from 'modules/FreeSupplier/routes';
import { MockDataProvider } from './state/MockDataContext';
import { UpgradeModalProvider } from './components/UpgradeModal';
import LiteShell from './components/LiteShell';
import GettingStartedPage from './pages/GettingStartedPage';
import CompanyPage from './pages/CompanyPage';
import InstallationsPage from './pages/InstallationsPage';
import EmissionFactorsPage from './pages/EmissionFactorsPage';
import TemplateUploadPage from './pages/TemplateUploadPage';
import DiagramViewPage from './pages/DiagramViewPage';
import SharePortalPage from './pages/SharePortalPage';
import DataRequestsPage from './pages/DataRequestsPage';
import EmbedWidgetPage from './pages/EmbedWidgetPage';
import UpgradePlansPage from './pages/UpgradePlansPage';
import RequestTailoredPage from './pages/RequestTailoredPage';
import RequestUploadPage from './pages/RequestUploadPage';
import RequestDirectEntryPage from './pages/RequestDirectEntryPage';
import DraftsInboxPage from './pages/DraftsInboxPage';
import DraftReviewPage from './pages/DraftReviewPage';

// The authenticated free-tier supplier journey. It runs on LIVE operator data
// (see state/MockDataContext.jsx — the provider reads/writes the same operator,
// installation, emission, S8 Supplier Page publication settings, and
// connection endpoints the full app uses) rendered inside its own slim shell
// (LiteShell).
//
// Mounted at /supplier as an outside route so it renders without the heavy
// AppLayout — see `isSupplierHomePath` in _app.jsx `isOutsideRoute` and the
// gated mount in _routes.jsx.
//
// Paths come from the canonical SupplierRoutePath (single source of truth,
// shared with the nav + S4 onboarding). Legacy hardcoded paths redirect so
// existing links / bookmarks keep working.
export default function SupplierApp() {
  return (
    <MockDataProvider>
      <UpgradeModalProvider>
        <LiteShell>
          <Switch>
            <Route
              exact
              path={SupplierRoutePath.Home}
              component={GettingStartedPage}
            />

            {/* Request-tailored surfaces — sub-routes before the exact parent. */}
            <Route
              path={SupplierRoutePath.RequestUpload}
              component={RequestUploadPage}
            />
            <Route
              path={SupplierRoutePath.RequestDirectEntry}
              component={RequestDirectEntryPage}
            />
            <Route
              exact
              path={SupplierRoutePath.Request}
              component={RequestTailoredPage}
            />

            <Route
              path={SupplierRoutePath.Company}
              component={CompanyPage}
            />
            <Route
              path={SupplierRoutePath.Installations}
              component={InstallationsPage}
            />
            <Route
              path={SupplierRoutePath.EmissionFactors}
              component={EmissionFactorsPage}
            />
            <Route
              path={SupplierRoutePath.Upload}
              component={TemplateUploadPage}
            />
            {/* Legacy path → canonical. */}
            <Redirect
              from="/supplier/template-upload"
              to={SupplierRoutePath.Upload}
            />

            {/* Draft review — sub-route (":draftId") before the exact list. */}
            <Route
              exact
              path={SupplierRoutePath.DraftReview}
              component={DraftReviewPage}
            />
            <Route
              exact
              path={SupplierRoutePath.Drafts}
              component={DraftsInboxPage}
            />

            <Route
              path={SupplierRoutePath.Diagram}
              component={DiagramViewPage}
            />
            <Route
              path={SupplierRoutePath.Share}
              component={SharePortalPage}
            />
            <Route
              path={SupplierRoutePath.Inbox}
              component={DataRequestsPage}
            />
            <Route
              path={SupplierRoutePath.Embed}
              component={EmbedWidgetPage}
            />
            {/* Legacy path → canonical. */}
            <Redirect
              from="/supplier/embed-widget"
              to={SupplierRoutePath.Embed}
            />
            <Route
              path="/supplier/upgrade"
              component={UpgradePlansPage}
            />
            <Redirect to={SupplierRoutePath.Home} />
          </Switch>
        </LiteShell>
      </UpgradeModalProvider>
    </MockDataProvider>
  );
}
